/**
 * @fileoverview 日付ユーティリティ util
 */
'use strict';
// Library Import
import _ from 'lodash';
import moment from 'moment';
import * as ConstUtil from './ConstUtil';

/** コンポーネント固有のメッセージ定義 */
const COMPONENT_MESSAGE = ConstUtil.Message.COMMON;
/**
 * 日時のフォーマット変換
 *
 * @name UnixTimeToDateString
 * @function
 * @memberOf utils.DateUtil
 * @param {Number} unixTime UnixTime
 * @param {String} tokens 出力フォーマット
 * @return {String} unixTimeを指定フォーマットに変換した文字列
 */
export const UnixTimeToDateString = (unixTime, tokens) => {
  // NaNチェック
  if (_.isNaN(unixTime)) {
    return '';
  }
  // 数値チェック
  if (!_.isNumber(unixTime)) {
    return '';
  }
  // 文字列チェック
  if (!_.isString(tokens)) {
    return '';
  }
  //moment.locale('ja');
  moment.locale(ConstUtil.Message.COMMON.JA, {
    weekdays: [
      COMPONENT_MESSAGE.SUNDAY,
      COMPONENT_MESSAGE.MONDAY,
      COMPONENT_MESSAGE.TUESDAY,
      COMPONENT_MESSAGE.WEDNESDAY,
      COMPONENT_MESSAGE.THURSDAY,
      COMPONENT_MESSAGE.FRIDAY,
      COMPONENT_MESSAGE.SATURDAY
    ],
    weekdaysShort: [
      COMPONENT_MESSAGE.SUNDAY_SH,
      COMPONENT_MESSAGE.MONDAY_SH,
      COMPONENT_MESSAGE.TUESDAY_SH,
      COMPONENT_MESSAGE.WEDNESDAY_SH,
      COMPONENT_MESSAGE.THURSDAY_SH,
      COMPONENT_MESSAGE.FRIDAY_SH,
      COMPONENT_MESSAGE.SATURDAY_SH
    ]
  });
  return moment(unixTime).format(tokens);
};

/**
 * 日付文字列からDateオブジェクト生成
 *
 * @param {String} dateString 日付文字列
 * @returns {Date} Dateオブジェクト
 */
export const StringToDate = (dateString, tokens) => {
  // 文字列チェック
  if (!_.isString(dateString)) {
    return '';
  }
  moment.locale('ja');
  return moment(dateString, tokens).toDate();
};

/**
 * 日時の加算
 *
 * @name AddDate
 * @function
 * @memberOf utils.DateUtil
 * @param {Date} date 日付
 * @param {String} displayPattern 日付のパターン
 * @param {Boolean} isAdd 加算か減算かを判定する値
 * @return {Date} dateを計算した値
 */
export const AddDate = (date, displayPattern, isAdd) => {
  // Dateチェック
  if (!_.isDate(date)) {
    return date;
  }
  // 日付のパターンチェック
  let pattern = _.findKey(ConstUtil.Common.MOMENT_KEYS, function(key) {
    if (displayPattern.indexOf(key) !== -1) {
      return key;
    }
  });
  if (_.isEmpty(pattern)) {
    return displayPattern;
  }
  // trueの場合は+1
  if (isAdd) {
    return moment(date)
      .add(1, displayPattern)
      .toDate();
  }
  // falseの場合は-1
  return moment(date)
    .add(-1, displayPattern)
    .toDate();
};

/**
 * 開始～終了が指定期間内かチェックする
 *
 * @param {Date} startDate 開始日
 * @param {Date} endDate 終了日
 * @param {Number} period 期間数
 * @param {String} displayPattern 日付のパターン
 * @returns {Boolean} True:期間内, False:期間外
 */
export const IsWithinPeriod = (startDate, endDate, period, displayPattern) => {
  // Dateチェック
  if (!_.isDate(startDate)) {
    return startDate;
  }
  if (!_.isDate(endDate)) {
    return endDate;
  }
  // Numberチェック
  if (!_.isNumber(period)) {
    return period;
  }
  // 日付のパターンチェック
  let pattern = _.findKey(ConstUtil.Common.MOMENT_KEYS, function(key) {
    if (displayPattern.indexOf(key) !== -1) {
      return key;
    }
  });
  if (_.isEmpty(pattern)) {
    return displayPattern;
  }
  // 終了日から期間数を減算
  let substractedDate = moment(endDate)
    .subtract(period, displayPattern)
    .toDate();
  // 開始日 >= 終了日の月-1
  return moment(startDate).isSameOrAfter(substractedDate);
};

/**
 * 日付文字列を別のフォーマットに置きかえた文字列を返す
 *
 * @param {String} beforeDateString
 * @param {String} token
 * @returns {String} 置き換え後の日付文字列
 */
export const changeDateFormat = (beforeDateString, token) => {
  if (_.isEmpty(beforeDateString)) {
    return beforeDateString;
  }
  //フォーマットの有無を判定
  if (_.isEmpty(token)) {
    return beforeDateString;
  }
  // Dateに変換
  let beforeDate = StringToDate(beforeDateString);
  if (!_.isDate(beforeDate)) {
    return beforeDateString;
  }
  // Stringに変換
  return UnixTimeToDateString(beforeDate.getTime(), token);
};



// WEBPACK FOOTER //
// ./src/js/util/DateUtil.jsx